'use client';

import { Clock } from 'lucide-react';
import { LinkNext, Skeleton, Text } from '@instamenu/ui-system-next';
import { themeVars } from '@instamenu/ui-vanilla-extract';
import { CheckoutRestaurantFieldsFragment, useCheckoutContext } from '@instamenu/context-checkout';
import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';
import { makePath } from '../utils';

export const OpeningHours = observer(
  ({ restaurant, menuId }: { restaurant: CheckoutRestaurantFieldsFragment; menuId?: string }) => {
    const checkout = useCheckoutContext();

    if (!restaurant.setting.openingHours) return null;

    const formatOpenDate = (date: DateTime) => {
      const res = date.hasSame(DateTime.now(), 'day')
        ? 'today'
        : date.hasSame(DateTime.now().plus({ days: 1 }), 'day')
          ? 'tomorrow'
          : date < DateTime.now().plus({ days: 7 })
            ? date.toFormat('cccc')
            : date.toFormat('LLLL d');
      return res + ' at ' + date.toFormat('h:mm a');
    };

    const nextOpening = checkout?.restaurant.hours.nextOpening;

    return (
      <LinkNext
        style={{ display: 'flex', alignItems: 'center', gap: 4 }}
        href={makePath({ restaurantId: restaurant.id, menuId, hours: true })}
      >
        <Clock size={16} />
        {checkout?.restaurant.hours.openingHoursThisWeek ? (
          checkout?.restaurant.hours.activeOpeningPeriod ? (
            <Text variant="caption1" css={{ color: themeVars.color.brand }}>
              Open until {checkout.restaurant.hours.activeOpeningPeriod.endTime.toFormat('h:mm a')}
            </Text>
          ) : (
            <Text variant="caption1">
              Closed
              {nextOpening ? ` · Opens ${formatOpenDate(nextOpening.startTime)}` : ''}
            </Text>
          )
        ) : (
          <Skeleton width={120} height={14} variant="text" />
        )}
      </LinkNext>
    );
  },
);
